export const COLORS = [
  { key: "mint", bg: "bg-mint", hex: "#B4F8C8" },
  { key: "peach", bg: "bg-peach", hex: "#FFCBB4" },
  { key: "lavender", bg: "bg-lavender", hex: "#D3C6F9" },
  { key: "butter", bg: "bg-butter", hex: "#FFE8A1" },
  { key: "sky", bg: "bg-sky-pastel", hex: "#A0E4F1" },
  { key: "cherry", bg: "bg-cherry", hex: "#FF9999" },
  // Neutral — blends with the app background. Great for teens who want
  // the card to look minimal / paperlike.
  { key: "neutral", bg: "bg-[color:var(--bg)]", hex: "#F6F3EC" },
];

// Resolve a member's stored color key to a {key, hex} pair. Prefers
// the unified 12-color MEMBER_COLORS palette (used as both the card
// tint and the calendar stripe); falls back to the legacy 7-color
// COLORS palette so older member docs (mint/peach/lavender/butter/
// sky/cherry/neutral) keep rendering until the family picks a new
// colour. Returns the first MEMBER_COLORS entry by default so a
// missing key never renders as transparent.
import { MEMBER_COLORS } from "@/lib/memberColors";

export const colorOf = (k) => {
  const key = (k || "").toString().trim().toLowerCase();
  const fresh = MEMBER_COLORS.find((c) => c.key === key);
  if (fresh) return { key: fresh.key, hex: fresh.hex };
  const legacy = COLORS.find((c) => c.key === key);
  if (legacy) return legacy;
  return { key: MEMBER_COLORS[0].key, hex: MEMBER_COLORS[0].hex };
};

export const AVATARS = [
  "🙂", "😎", "🤓", "🥰", "😇", "🤗", "😴", "🤠",
  "🦊", "🐻", "🐼", "🐨", "🦁", "🐯", "🐵", "🦄",
  "🐶", "🐱", "🐰", "🐸", "🐙", "🦉", "🌸", "⭐",
  // Pet pack: fish, hamster, turtle, bird, reptile + some extras
  "🐟", "🐠", "🐹", "🐢", "🐦", "🦜", "🦎", "🐍",
];

export const STATUS_OPTIONS = [
  { key: "home", label: "At home", emoji: "🏠" },
  { key: "work", label: "Work", emoji: "💼" },
  { key: "school", label: "At school", emoji: "🎒" },
  { key: "out", label: "Out with friends", emoji: "🚶" },
  { key: "shopping", label: "Out shopping", emoji: "🛍️" },
  { key: "away", label: "Away / traveling", emoji: "✈️" },
];

export const ADULT_STATUS_OPTIONS = [
  { key: "home", label: "At home", emoji: "🏠" },
  { key: "work", label: "Work", emoji: "💼" },
  { key: "shopping", label: "Out shopping", emoji: "🛍️" },
  { key: "away", label: "Away / traveling", emoji: "✈️" },
];

export const KID_STATUS_OPTIONS = [
  { key: "home", label: "At home", emoji: "🏠" },
  { key: "school", label: "At school", emoji: "🎒" },
  { key: "out", label: "Out with friends", emoji: "🚶" },
];

export function statusOptionsFor(role) {
  return role === "kid" ? KID_STATUS_OPTIONS : ADULT_STATUS_OPTIONS;
}

export const statusOf = (k) =>
  STATUS_OPTIONS.find((s) => s.key === k) || STATUS_OPTIONS[0];

export const DEFAULT_TAGS = [
  { key: "tired", label: "Tired", emoji: "🥱" },
  { key: "energetic", label: "Energetic", emoji: "⚡" },
  { key: "happy", label: "Happy", emoji: "😊" },
  { key: "grouchy", label: "Grouchy", emoji: "😤" },
  { key: "anxious", label: "Anxious", emoji: "😟" },
  { key: "stressed", label: "Stressed", emoji: "😖" },
  { key: "sick", label: "Feeling unwell", emoji: "🤒" },
];

export const REACTION_EMOJIS = ["👍", "❤️", "😂", "🙌", "🤗", "😮"];

// sleep 1-10 -> color
export function sleepToColor(v) {
  if (v == null) return "#F3F0E9";
  if (v <= 3) return "#FFCBB4"; // peach
  if (v <= 6) return "#FFE8A1"; // butter
  return "#B4F8C8"; // mint
}

export function moodToColor(v) {
  if (v == null) return "#F3F0E9";
  if (v <= 3) return "#FF9999"; // cherry
  if (v <= 6) return "#D3C6F9"; // lavender
  return "#A0E4F1"; // sky
}
